// extracted by mini-css-extract-plugin
export default {"pageWrapper":"pagewrapper_pageWrapper__S+4rp","space":"pagewrapper_space__vfYn-"};